import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { Service } from '../../app/service';
import { ThemenSelector } from '../thema/thema';

@Component({
  selector: 'page-stufe',
  templateUrl: 'stufe.html'
})

export class StufenSelector {

  //DataProvider = new Service();
  levels: any;
  mode: any;

  constructor(public navCtrl: NavController, private navParams: NavParams, private DataProvider: Service) {
    this.mode = navParams.get('mode');
    this.levels = DataProvider.getLevels();
    console.log("levels: ", this.levels);
  }

  openLevel(event, data) {
    this.navCtrl.push(ThemenSelector, {mode: this.mode, level: data});
    console.log("open level", event, data);
  };

}



// WEBPACK FOOTER //
// ./src/pages/stufe/stufe.ts